export default __webpack_public_path__ + "static/media/bK.0843f9c4.svg";